module.exports = __webpack_public_path__ + "media/src/website/images/svg/hamburger-98d24042258a92ce9a4bb3c332f130ba.svg";